import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import immutableStateInvariant from 'redux-immutable-state-invariant';

const middlewares = [
  thunk
];

if (process.env.NODE_ENV === 'development') {
  // ignoring campaignImages because there is a problem with input: files
  middlewares.push(immutableStateInvariant({
    ignore: ['campaignAssets.assets']
  }));
}

// Add a dictionary to keep track of the registered async reducers
const asyncReducers = {};

export function getStore(initialState) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const combinedReducers = (Object.values(asyncReducers).length > 0)
    ? combineReducers(asyncReducers)
    : (() => {});

  return createStore(combinedReducers, initialState, composeEnhancers(
    applyMiddleware(...middlewares)
  ));
}

const store = getStore();

// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
export function injectReducer(key, asyncReducer) {
  if (asyncReducers[key]) {
    // eslint-disable-next-line no-console
    console.error(`Trying to overwrite already defined reducer ${key}`);
  }
  asyncReducers[key] = asyncReducer;
  store.replaceReducer(combineReducers(asyncReducers));
}

export default store;
